module.exports = __webpack_public_path__ + "static/media/edit_constraints_course_flags.664dfadb.mov";